// bucketSlice.js
import { createSlice, createSelector } from '@reduxjs/toolkit';

const initialState = {
  items: [],
};

const bucketSlice = createSlice({
  name: 'bucket',
  initialState,
  reducers: {
    addItemToBucket: (state, action) => {
      const { id, addOns } = action.payload;
      const existingItem = state.items.find(item => item.id === id);

      if (existingItem) {
        // If the item with the same id already exists, increase the quantity
        existingItem.quantity += 1;

        // Add add-ons to the existing item
        if (addOns) {
          existingItem.addOns = existingItem.addOns.concat(addOns);
        }
      } else {
        // If the item doesn't exist in the bucket, add a new item with a quantity of 1
        state.items.push({ ...action.payload, quantity: 1 });
      }
    },
    removeItemFromBucket: (state, action) => {
      const existingItem = state.items.find(item => item.id === action.payload.id);

      if (existingItem) {
        // Decrease the quantity by 1
        existingItem.quantity -= 1;

        // If the quantity reaches 0, remove the item
        if (existingItem.quantity === 0) {
          state.items = state.items.filter(item => item.id !== action.payload.id);
        }
      }
    },
    clearBucket: (state) => {
      state.items = [];
    },
    addAddOn: (state, action) => {
      const { itemId, addOn } = action.payload;
      const item = state.items.find(item => item.id === itemId);
    
      if (item) {
        if (!item.addOns) {
          item.addOns = []; // Initialize the add-ons array if it doesn't exist
        }
        item.addOns.push(addOn);
      } else {
        // Create a new item with the provided add-on and set quantity to 1
        state.items.push({ ...action.payload.item, addOns: [addOn], quantity: 1 });
      }
    }
    ,
    removeAddOn: (state, action) => {
      const { itemId, addOnId } = action.payload;
      const item = state.items.find(item => item.id === itemId);
      if (item && item.addOns) {
        item.addOns = item.addOns.filter(addOn => addOn.id !== addOnId);
      }
    },
  },
});

export const { addItemToBucket, removeItemFromBucket, clearBucket, addAddOn, removeAddOn } = bucketSlice.actions;

// Selector to calculate the total cost and total number of items
export const selectBucket = state => state.bucket.items;
export const selectTotalCost = createSelector(selectBucket, items => {
  return items.reduce((total, item) => total + item.price * item.quantity, 0);
});
export const selectTotalQuantity = createSelector(selectBucket, items => {
  return items.reduce((total, item) => total + item.quantity, 0);
});

export default bucketSlice.reducer;
